import { render, staticRenderFns } from "./DomainPreview.vue?vue&type=template&id=59ed2ff2&"
import script from "./DomainPreview.vue?vue&type=script&lang=js&"
export * from "./DomainPreview.vue?vue&type=script&lang=js&"
import style0 from "./DomainPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports